import LeadEvent, {LeadEventTypeEnum} from "./LeadEvent";
import * as moment from "moment";
import {LeadEventApiDto, LeadStatusEventDataApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import {getLeadStatus} from "../../../store/view/leadStatus";

/**
 * Lead status changed event.
 */
export default class LeadStatusEvent extends LeadEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {string} leadId lead id.
	 * @param {LeadEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} entity entity which creates the event.
	 * @param {moment.Moment} creationDate creation date of event.
	 * @param {string} referenceNumber lead reference number.
	 * @param {LeadStatusEventData} data lead status change event data.
	 */
	constructor(public readonly id: string,
		public readonly leadId: string,
		public readonly type: LeadEventTypeEnum,
		public readonly entity: AuthenticatedEntity,
		public readonly creationDate: moment.Moment,
		public readonly referenceNumber: string,
		public readonly data: LeadStatusEventData) {
		super(id, leadId, type, entity, creationDate, referenceNumber);
	}

	public static fromJson(json: LeadEventApiDto): LeadStatusEvent {
		const data = LeadStatusEventData.fromJson(json.data as LeadStatusEventDataApiDto);
		const entity = AuthenticatedEntity.fromJson(json.entity);
		return new LeadStatusEvent(json.id, json.leadId, LeadEventTypeEnum.StatusChanged, entity,
			moment(json.createdAt), json.referenceNumber, data);
	}

	getIcon() {
		return Icon.Status;
	}

	getActivityType(): string {
		return `STATUS`
	}

	getActivityMessage(): string {
		const currentStatusLabel = getLeadStatus(this.data.currentStatusId).map(s => s.getStatusLabel());
		return `Status Changed ${currentStatusLabel.map(l => `to ${l}`).getOrElse("to UNKNOWN")}`
	}
}

export class LeadStatusEventData {
	constructor(public readonly currentStatusId: string, public readonly previousStatusId: string) {}

	public static fromJson(json: LeadStatusEventDataApiDto): LeadStatusEventData {
		return new LeadStatusEventData(json.currentStatus, json.previousStatus);
	}
}
